<div class="grid-x margin-bottom">
  <div class="cell large-1">
    @switch (true) {
      @case (alert.alertType !== alertTypes.Information && !alert.resolved) {
        <svg-icon class="x-large" icon="icon-alert"></svg-icon>
      }
      @case (alert.alertType !== alertTypes.Information && alert.resolved) {
        <svg-icon class="x-large green" icon="icon-checkbox"></svg-icon>
      }
      @default {
        <svg-icon class="x-large" icon="icon-help"></svg-icon>
      }
    }
  </div>
  <div class="cell large-11" [ngClass]="{ red: alert.alertType !== alertTypes.Information && !alert.resolved }">
    {{alert.text}}
  </div>
</div>
